import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Receipt } from "lucide-react";

interface RevenueByPlanCardProps {
  data: {
    planDays: number;
    label: string;
    revenue: number;
    count: number;
    avgTicket: number;
  }[];
}

export const RevenueByPlanCard = ({ data }: RevenueByPlanCardProps) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const maxRevenue = Math.max(...data.map(d => d.revenue), 1);

  if (!data || data.length === 0) {
    return (
      <Card className="border-border/50 bg-card/50 backdrop-blur-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg flex items-center gap-2">
            <Receipt className="h-5 w-5 text-indigo-500" />
            Ingresos por Plan
          </CardTitle>
        </CardHeader>
        <CardContent className="h-64 flex items-center justify-center">
          <p className="text-muted-foreground">No hay datos de planes disponibles</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-border/50 bg-card/50 backdrop-blur-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2">
          <Receipt className="h-5 w-5 text-indigo-500" />
          Ingresos por Plan
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {data.map((plan) => (
          <div key={plan.planDays} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-foreground">{plan.label}</span>
                <span className="text-xs text-muted-foreground">({plan.planDays} días)</span>
              </div>
              <span className="text-sm font-bold text-foreground">{formatCurrency(plan.revenue)}</span>
            </div>
            <Progress 
              value={(plan.revenue / maxRevenue) * 100} 
              className="h-2"
            />
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>{plan.count} pagos</span>
              <span>Ticket prom: {formatCurrency(plan.avgTicket)}</span>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
